import './entity.less';
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import min from 'lodash/min';
import max from 'lodash/max';
import get from 'lodash/get';
import Currency from  './currency';
import SelectField from '../../../../../shared/form-elements/select/field';

import dashboard from '../../../../../../config/dashboard';

const Entity = ({
	className,
	type,
	parentName,
	payoutCurrencies,
	index,
	intl,
	fields,
	placeholder,
	entityLookup,
	savedTerms,
	selectedCurrenciesPanIndexMap,
	onRemoveField,
	onToggleTargetPan,
	onFetchDefaultTarget,
	onChangeCurrency,
	onDeleteOffers,
	isMaster
}) => (
	<tr
		className={`entity-target ${className}`} onClick={e => onToggleTargetPan(index)}>
		<td className="entity-type">
			<Field
				name={`${parentName}.${type}`}
				placeholder={placeholder}
				component={SelectField}
				disabled={!!savedTerms[index]}
				onChange={ entity => onFetchDefaultTarget(index, entity[0]) }
				multi={false}
				showLabel={false}
				options={entityLookup} />
		</td>
		<td className="entity-geo"><span>{ calculateTotalGeo(index, fields) }</span></td>
		<td className="entity-payout">
			<span>{ calculateMinMaxPayout(
				index,
				fields,
				[selectedCurrenciesPanIndexMap[index] || 'usd']
			) }</span>
		</td>
		<td className="entity-currencies">
			<Currency
				availableCurrencies={payoutCurrencies}
				currentFieldTargets={get(fields.getAll()[index], 'targets')}
				selectedCurrenciesPanIndexMap={selectedCurrenciesPanIndexMap}
				fieldIndex={index}
				onChangeCurrency={onChangeCurrency} />
		</td>
		<td className="entity-actions">
			<div className="actions__wrap">
				<a
					className="copy"
					title='Copy'
					href="#"
					onClick={(e) => {
						e.stopPropagation();
						e.preventDefault();

						const offerId = fields.get(index).offer[0].value;

						navigator.clipboard.writeText(`${dashboard.baseURL}/offers/${offerId}`);
					}}
				/>
				<span className="delete" onClick={e => {
					e.stopPropagation();
					const confirmWarning = isMaster ?
						intl('Delete user offer%s Child payouts are going to be reset.', '?') :
						intl('Delete user offer%s', '?');

					const offer = get(fields.getAll()[index], 'offer');

					if (savedTerms[index] && !confirm(confirmWarning)) {
						return;
					}

					fields.remove(index);
					savedTerms[index] && onDeleteOffers(offer[0]['value']);
				}} />
				<span className="toggle" />
			</div>
		</td>
	</tr>
);

Entity.propTypes = {
	className: PropTypes.string,
	type: PropTypes.string,
	parentName: PropTypes.string,
	index: PropTypes.any,
	intl: PropTypes.func,
	fields: PropTypes.object,
	placeholder: PropTypes.string,
	savedTerms: PropTypes.array,
	selectedCurrenciesPanIndexMap: PropTypes.object,
	onToggleTargetPan: PropTypes.func,
	onFetchDefaultTarget: PropTypes.func,
	entityLookup: PropTypes.func,
	onRemoveField: PropTypes.func,
	onChangeCurrency: PropTypes.func,
	onDeleteOffers: PropTypes.func,
	isMaster: PropTypes.bool
};

const calculateTotalGeo = (index, fields) => {
	const targets = (fields.getAll())[index]['targets'] || [];
	return targets.filter(entity => entity.rub || entity.usd).length;
};

const calculateMinMaxPayout = (index, fields, currency = 'rub') => {
	const targets = (fields.getAll())[index]['targets'] || [];

	const getAllAmount = targets.map(entity => +entity[currency]);
	const minValue = min(getAllAmount) || 0;
	const maxValue = max(getAllAmount) || 0;
	return `${minValue} - ${maxValue}`;
};

export default Entity;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/profile/forms/individual-terms/entity.js